export enum SidebarEvents {
    OPEN = '@sidebar/OPEN',
    CLOSE = '@sidebar/CLOSE'
}
